/**
 * @ngdoc service
 * @name common.service:UserService
 * @description
 * A User's service that handles the use related information. Everything concerned to the ´inditex.iUserJSON´ object should be 
 * handled here.
 */
(function() {
    'use strict';

    angular
        .module('itxApp.common')
        .service('UserService', UserService);

    UserService.$inject = [
        '$q',
        'itxAkamaiSvc',
        'CmsConfigSvc',
        'ngDialog',
        'ItxTranslateSvc',
        '$rootScope',
        'ItxShopCartFct',
        'ItxConfigurationSvc',
        'NavigationService'
    ];

    function UserService(
        $q,
        itxAkamaiSvc,
        CmsConfigSvc,
        ngDialog,
        ItxTranslateSvc,
        $rootScope,
        ItxShopCartFct,
        ItxConfigurationSvc,
        NavigationService
    ) {
        var _this = this;

        _this.loggedUser = false;

        _this.user = {
            type: {
                GUEST: 'G',
                SEMI_GUEST: 'S',
                REGISTER: 'R',
                WALLET: 'W',
                SEMI_WALLET: 'WS'
            }
        };

        _this.reloadModalsCmsKey = 'reload_modals_enabled';

        _this.reloadModalsConfig = {
            'BF_2019': {
                templateUrl: 'bf-reload-modal.component.html',
                cmsDateKey: 'blackfriday_date_range',
                reloadTimeout: null
            }
        };

        var service = {
            getUserFullName: getUserFullName,
            getUserName: getUserName,
            getUserType: getUserType,
            iAmGuest: iAmGuest,
            isVip: isVip,
            isVipPeriod: isVipPeriod,
            isDesfilePeriod: isDesfilePeriod,
            user: _this.user,
            isVipEnabled: isVipEnabled ,
            getCurrentUser: getCurrentUser,
            showVipModal: showVipModal,
            clearCache: clearCache,
            isAuthenticated: isAuthenticated,
            getUserIsVip: _getUserIsVip,
            setUserIsVip: _setUserIsVip,
            setUserIsNoVip: _setUserIsNoVip,
            resetUserVipType: _resetUserVipType,
            showReloadPageModal: showReloadPageModal,
            verifyVip: _verifyVip,
            getUserVipType: _getUserVipType,
            haveEmail: _haveEmail
        };
        var isVipCache;

        $rootScope.$on('login:success', function (event, loggedUser) {
            if (loggedUser) {
                _this.loggedUser = true;
            }
            _verifyVip().then(function(data) {
                if(data.isVipSales && data.isVipUser) {
                    showVipModal();
                }
            }).catch(function(err) {
                console.error(err)
            });
        });

        return service;

        
        function isAuthenticated() {
            if (_this.loggedUser) {
                return true;
            }
            return joyr.user.utils.isAuthenticated();
        }

        function _getUserIsVip() {
            var state = inditex.getLocalStorage('USER_VIP') === 'true' ? true : false;
            return state;
        }

        /**
         * Función para establecer el usuario como VIP
         */
        function _setUserIsVip() {
            inditex.setLocalStorage('USER_VIP', 'true');
            inditex.setLocalStorage('USER_360', 'true');
            inditex.setLocalStorage('USER_NWL', 'true');
        }

        /**
         * Función para establecer el usuario como NO VIP
         */
        function _setUserIsNoVip() {
            inditex.setLocalStorage('USER_VIP', 'false');
            inditex.setLocalStorage('USER_360', 'false');
            inditex.setLocalStorage('USER_NWL', 'false');
        }

        /**
         * Función para obtener el tipo de usuario (VIP)
         */
        function _getUserVipType() {
            return inditex.getLocalStorage('USER_VIP');
        }

        /**
         * Función para reestablecer usuario (VIP)
         */
        function _resetUserVipType() {
            inditex.removeLocalStorage('USER_VIP');
            inditex.removeLocalStorage('USER_360');
            inditex.removeLocalStorage('USER_NWL');
        }

        /**
        * @ngdoc method
        * @name isVipEnabled
        * @methodOf 
        * @description
        * Comprobamos que inditex está cargado para devolver un booleano sobre si el usuario es VIP y está en peridodo VIP
        */
        function isVipEnabled(){
            var deferred = $q.defer();
            var isDebug = ItxConfigurationSvc.isDebugActive();
            if (_getUserIsVip()) {
                deferred.resolve( true );
            } else if (isDebug) {
                deferred.resolve(false);
            } else {
                inditex.onReady(function () {
                    deferred.resolve( service.isVip() );
                });
            }
            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name getUserFullName
         * @methodOf common.service:UserService
         * @description
         * Get complete name from an address
         * @param {object} address Address object
         * @returns {string || null } user name and lastname
         */
        function getUserFullName(address) {
            if (!address) {
                return;
            }
            if (inditex.iStoreJSON.details.isMiddleName) {
                return address.firstName + ' ' + address.middleName + ' ' + address.lastName;
            } else {
                return address.firstName + ' ' + address.lastName;
            }
        }

        /**
         * @ngdoc method
         * @name getUserlName
         * @methodOf common.service:UserService
         * @description
         * Get the username from an address
         * @param {object} address Address object
         * @returns {string || null } username
         */
         function getUserName(address) {
            if (!address) {
                return;
            }
            return address.firstName;
        }


        /**
         * @ngdoc method
         * @name getUserType
         * @methodOf common.service:UserService
         * @description
         * Get user type.
         * Uses Xconfiguration variable `FULL_ADDRESS_MASK`
         * @returns {string} user type
         */
        function getUserType() {

            var deferred = $q.defer();

            if (inditex.iUserJSON && inditex.iUserJSON.userType) {
                if (inditex.iUserJSON.userType === _this.user.type.GUEST) {
                    deferred.resolve(_this.user.type.GUEST);
                } else {
                    if (inditex.iFullAddressMask) {
                        if (inditex.iFullAddressMask &&
                            inditex.iUserJSON.personalDataLevel &&
                            ((inditex.iUserJSON.personalDataLevel && inditex.iFullAddressMask) ==
                                inditex.iFullAddressMask)) {
                            deferred.resolve(inditex.iUserJSON.isWalletUser ? _this.user.type.WALLET : _this.user.type.REGISTER);
                        } else {
                            deferred.resolve(inditex.iUserJSON.isWalletUser ? _this.user.type.SEMI_WALLET : _this.user.type.SEMI_GUEST);
                        }
                    } else {
                        inditex.iFullAddressMask = inditex.xconf['FULL_ADDRESS_MASK'];
                        if (inditex.iFullAddressMask &&
                            inditex.iUserJSON.personalDataLevel &&
                            ((inditex.iUserJSON.personalDataLevel && inditex.iFullAddressMask) ==
                                inditex.iFullAddressMask)) {
                            deferred.resolve(inditex.iUserJSON.isWalletUser ? _this.user.type.WALLET : _this.user.type.REGISTER);
                        } else {
                            deferred.resolve(inditex.iUserJSON.isWalletUser ? _this.user.type.SEMI_WALLET : _this.user.type.SEMI_GUEST);
                        }
                    }
                }
            } else {
                deferred.resolve(_this.user.type.GUEST);
            }
            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name iAmGuest
         * @methodOf common.service:UserService
         * @description
         * Check if current user is guest.
         * @return {boolean} guest or not.
         */
        function iAmGuest() {
            return !inditex.iUserJSON || !inditex.iUserJSON.userType || (inditex.iUserJSON.userType === _this.user.type.GUEST);
        }
        /**
         * @ngdoc method
         * @name isVip
         * @methodOf common.service:UserService
         * @description
         * Tiene en cuenta 3 consideraciones:
         * - inditex.iUserJSON.showPrivateSale == true
         * - la Estamos en periodo VIP
         * @return {boolean} VIP or not.
         */


        function isVip() {
            if (inditex.iUserJSON) {
                return inditex.iUserJSON.showPrivateSale == true ;
            } else {
                return false
            }
        }

        

         /**
         * @ngdoc method
         * @name isVipPeriod
         * @methodOf common.service:UserService
         * @description
         * Comprueba si el usuario es vip, si  las fechas del cms de  vip_date_range
         * están bien definidas y si el usuario Vip está en ese rango de fechas
         * @return {Promise<boolean>} is Vip or not.
         */
        function isVipPeriod() {
            
             var deferred = $q.defer();
             
             if(isVipCache){
                deferred.resolve(isVipCache);
             }

             $q.all({
                date: itxAkamaiSvc.getDate(),
                vipRange:CmsConfigSvc.getProperty('vip_date_range')
             })
             .then(function(obj){
                 
                if(!obj.vipRange.startDate || ! obj.vipRange.endDate){       
                    console.error('Invalid params provided in vip_date_range, need startDate, endDate with format:  YYYY-MM-DD HH:mm:ss');
                    deferred.reject('Invalid params provided in vip_date_range, need startDate, endDate with format:  YYYY-MM-DD HH:mm:ss');
                    return;
                }

                var init = moment.tz(obj.vipRange.startDate, 'YYYY-MM-DD HH:mm:ss' ,'Europe/London');
                var end = moment.tz(obj.vipRange.endDate, 'YYYY-MM-DD HH:mm:ss','Europe/London');
                isVipCache = obj.date.isBetween(init, end);                
                
                deferred.resolve(isVipCache);
            })
            .catch(function(err){
                console.trace(err)
                
                deferred.resolve(false);
            });
    
            return deferred.promise;
        }

        function isDesfilePeriod(){
            var deferred = $q.defer();

            CmsConfigSvc.getProperty('desfile_date')
            .then(function(info){
                itxAkamaiSvc.getDate().then(function(date) {
                    var initDesfile = moment.tz(info.startDate, 'YYYY-MM-DD HH:mm:ss' ,'Europe/London');
                    var initDesfileDate = new Date(initDesfile._i);
                    var d = new Date(date._i);
                    var isDesfileRange = d >= initDesfileDate;
                    deferred.resolve(isDesfileRange);
                });            
            })
            .catch(function(err){
                deferred.reject();
                console.error("Error getting desfile date");
            })

            return deferred.promise;
        }

        function getCurrentUser() {
            var deferred = $q.defer();

            clearCache()
                .then(function () {
                    inditex.execute({
                        actions: [
                            {
                                action: 'user:currentUser',
                                params: {
                                    storeId: inditex.iStoreId,
                                    languageId: inditex.iLangId,
                                    catalogId: inditex.iCatalogId
                                }
                            }
                        ],
                        onFinish: function () {
                            deferred.resolve(inditex.iUserJSON);
                        }
                    });
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function showVipModal(){
            var closeAndReload = true;
            if(inditex.iPage === 'ItxCheckoutAuthPage'){
                sessionStorage.setItem('SHOW_VIP_MODAL', true );
            }
            else{
                if(sessionStorage.getItem('SHOW_VIP_MODAL')){
                    closeAndReload = false;
                }
                ngDialog.close();
                sessionStorage.removeItem('SHOW_VIP_MODAL' );   
                $('.ngdialog ').css('display','none');
                setTimeout(function()  {
                    var helloValue = '';
                    CmsConfigSvc.getTranslation('hello.name',[inditex.iUserJSON.firstName])
                    .then(function(value){
                        helloValue = value;
                    })
                    .finally(function(){
                        $('.ngdialog ').css('display','block');
                        ngDialog.open({ 
                            template: 'vip-confirmation-modal.component.html',
                            className: 'new-modal ma-modal-sm ma-modal-vip ngdialog-theme-plain',
                            showClose: false,
                            data: {
                                hello: helloValue,
                                clickAccept:function(){
                                    ngDialog.close();
                                    if(closeAndReload){
                                        if(NavigationService.isHomePage()){
                                            NavigationService.goToHomePage();
                                        } else {
                                            document.location.reload();
                                        }
                                    }
                                }
                            },
                            preCloseCallback:function () {
                                if(closeAndReload){
                                    if(inditex.iPage !=='ItxMyAccountPage'){
                                        if(NavigationService.isHomePage()){
                                            NavigationService.goToHomePage();
                                        } else {
                                            document.location.reload();
                                        }
                                    }
                                }
                            }
                        });
                    });
                }, 200);   
            }
        }

        function showReloadPageModal(modalKey){
            var reloadModalConfig = _this.reloadModalsConfig[modalKey];
            if(!_reloadModalConfigCorrect(reloadModalConfig)){
                console.error('Incorrect configurat for reload modal:',modalKey);
                return;
            }

            CmsConfigSvc.getProperty(_this.reloadModalsCmsKey)
            .then(function(reloadModalsActive){
                if(reloadModalsActive){
                    CmsConfigSvc.getProperty(reloadModalConfig.cmsDateKey)
                    .then(function(info){
                        itxAkamaiSvc.getDate().then(function(date) {
                            var initReload = moment.tz(info.from, 'YYYY-MM-DD HH:mm:ss' ,'Europe/Madrid');
                            var currentDate = moment(date).tz('Europe/Madrid');

                            if(currentDate.isValid() && initReload.isValid()){
                                if(reloadModalConfig.reloadTimeout){ //reseteamos el timeout para evitar tener dos reloads.
                                    clearTimeout(reloadModalConfig.reloadTimeout);
                                    reloadModalConfig.reloadTimeout = null;
                                }
    
                                var itsReloadTime = currentDate._d >= initReload._d;
    
                                if(!itsReloadTime){
                                    var msDiff = (initReload._d.getTime()-currentDate._d.getTime())+1000;
                                    // console.log('Falten',(msDiff/1000),'segons per obrir el popup');
                                    reloadModalConfig.reloadTimeout = setTimeout(function(){
                                        _openReloadModal(reloadModalConfig);
                                    },msDiff);
                                }
                            }
                        });            
                    })
                    .catch(function(err){
                        console.error('Error getting CMS key:',reloadModalConfig.cmsDateKey);
                    });
                }
            })
            .catch(function(err){
                console.error('Error getting CMS key:',_this.reloadModalsCmsKey);
            });
        }

        function _reloadModalConfigCorrect(config){
            if(
                !config ||
                !config.templateUrl || 
                !config.cmsDateKey
            ){
                return false;
            }

            return true;
        }

        function _openReloadModal(modalConfig){
            ngDialog.open({ 
                template: modalConfig.templateUrl,
                className: 'new-modal ma-modal-sm ma-modal-vip ngdialog-theme-plain',
                showClose: true,
                data: {
                    clickAccept:function(){
                        ngDialog.close();
                    }
                },
                preCloseCallback:function () {
                    service.getCurrentUser().finally(function(){
                        //Refrescamos el iUserJSON para el nuevo valor de crmAccepted
                        location.reload();
                    });
                }
            });
        }

        function clearCache() {
            var deferred = $q.defer();

            ItxShopCartFct.getCart()
                .then(function () {
                    sessionStorage.removeItem('cache-current-user');
                    sessionStorage.removeItem('VIPCART');
                    // localStorage.removeItem('cache-shop-cart');
                    deferred.resolve();
                })
                .catch(function () {
                    console.error('ERROR OBTENIENDO EL CARRITO AL BORRAR LA CACHÉ.');
                    deferred.reject();
                });

            return deferred.promise;
        }

        function verifyVipSales() {
            var deferred = $q.defer(); 
            
            CmsConfigSvc.getProperty('vip_sales_date_range')
            .then(function(info){
                itxAkamaiSvc.getForcedCurrentDate().then(function(date) {
                    var initDateConfig = moment.tz(info.from, 'YYYY-MM-DD HH:mm:ss', 'Europe/Madrid');
                    var endDateConfig = moment.tz(info.to, 'YYYY-MM-DD HH:mm:ss', 'Europe/Madrid');
                    date = moment.tz(date, 'Europe/Madrid');
                    deferred.resolve(date.isBetween(initDateConfig, endDateConfig));
                }).catch(function(err){
                    console.error('Error getting Akamai date');
                    deferred.resolve(false);
                })
            })
            .catch(function(err){
                console.error('Error getting CMS key:', 'vip_sales_date_range');
                deferred.resolve(false);
            });
            
            return deferred.promise;
        }

        function _verifyVip() {
            var deferred = $q.defer();
            var promises = [];
            var isDebug = ItxConfigurationSvc.isDebugActive();

            promises.push(isVipEnabled());
            if(!isDebug){
                promises.push(verifyVipSales());
            }

            $q.all(promises)
            .then(function (data) {
                var obj = {
                    isVipUser: data[0],
                    isVipSales: isDebug || data[1]
                };

                deferred.resolve(obj);
            }).catch(function(data) {
                deferred.reject(data);
            });
            return deferred.promise;
        }

        function _haveEmail() {
            let email = false;
            const regexp = joyr.validation.regex.email();
            
            if(inditex.iUserJSON && regexp && 
                (inditex.iUserJSON.email && regexp.test(inditex.iUserJSON.email)) || 
                (inditex.iUserJSON.logon && regexp.test(inditex.iUserJSON.logon)) ) {
                email = true;
            }

            return email;
        }
    }
})();